import { Pill } from '@shared/components/pill';
import { NumberField } from '@shared/data/entity/fields/NumberField';
import { CardCollectionViewFieldContainer } from './CardCollectionViewFieldContainer';

interface Props {
  field: NumberField;
}

export function NumberCollectionViewField({ field }: Props) {
  if (field.isEmpty) {
    return null;
  }

  return (
    <CardCollectionViewFieldContainer fieldType={field.fieldType}>
      <Pill sections={[field.formattedValue]} />
    </CardCollectionViewFieldContainer>
  );
}
